import apis from "../../core/apis.js";

class PrivateBusPricingResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.pricing).get(options);
  }

  get(id) {
    return this.$resource(apis.pricing + id).get();
  }

  search(search = "") {
    return this.$resource(apis.pricing).get({ search });
  }

  post(item) {
    return this.$resource(apis.pricing).save(item);
  }
  updateItem(id, item) {
    return this.$resource(apis.pricing + id).save(item);
  }
  update(id, item) {
    return this.$resource(apis.pricing + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
  updateAction(id, name, item) {
    return this.$resource(apis.pricing + id + `/${name}`).save(item);
  }
}

export default PrivateBusPricingResource;



// WEBPACK FOOTER //
// ./src/resources/privateBusPricing/privateBusPricing.resource.js